/* Christina — pelna lista ISO 3166-1 alpha-2 dla formularzy Pro  (T73, 2026-08-26)
 *
 * POWOD ISTNIENIA TEGO PLIKU
 * T72 zawezil pole kraju do 29 pozycji i dolozyl serwerowy kod bledu
 * COUNTRY_UNSUPPORTED. To przywrocilo tylnymi drzwiami bramke krajowa, ktora
 * decyzja GM CEE z 26.08.2026 zostala zdjeta swiadomie (deploy 50f5ce54):
 * o dostepie Pro decyduje weryfikacja REJESTROWA, nie kraj. Od T73 kazdy poprawny
 * kod ISO 3166-1 alpha-2 pozwala wyslac zgloszenie; brak adaptera rejestrowego
 * konczy sie MANUAL_REVIEW z konkretna przyczyna, nigdy odmowa i nigdy blokada pola.
 *
 * LOKALIZACJA NAZW
 * Nazwy krajow budujemy przez Intl.DisplayNames w jezyku strony (pl / en / zh-TW).
 * Wbudowana tablica angielskich nazw ISO jest wylacznie fallbackiem dla przegladarek
 * bez Intl.DisplayNames. Dzieki temu nie duplikujemy 249 nazw x 3 jezyki w motywie.
 *
 * PROGRESSIVE ENHANCEMENT
 * Funkcja PODMIENIA zawartosc istniejacego <select>. Sekcje zostawiaja w HTML krotka
 * liste krajow z adapterem jako baseline dla przegladarki bez JS (formularz i tak
 * wymaga fetch, wiec bez JS nie dziala w calosci).
 */
(function (w) {
  "use strict";

  /* Kraje z dzialajacym adapterem rejestrowym w silniku weryfikacji (worker
     christina-backend). Wylacznie kolejnosc na liscie i etykieta grupy — to NIE jest
     bramka i nie wolno jej tak uzywac. */
  var TOP = ["PL", "CZ", "SK", "FR", "FI", "RO", "NO", "DK", "GB", "BE"];

  /* 249 kodow oficjalnie przypisanych w ISO 3166-1 alpha-2 + angielska nazwa skrocona. */
  var RAW =
    "AD:Andorra|AE:United Arab Emirates|AF:Afghanistan|AG:Antigua and Barbuda|AI:Anguilla|AL:Albania|" +
    "AM:Armenia|AO:Angola|AQ:Antarctica|AR:Argentina|AS:American Samoa|AT:Austria|AU:Australia|AW:Aruba|" +
    "AX:Aland Islands|AZ:Azerbaijan|BA:Bosnia and Herzegovina|BB:Barbados|BD:Bangladesh|BE:Belgium|" +
    "BF:Burkina Faso|BG:Bulgaria|BH:Bahrain|BI:Burundi|BJ:Benin|BL:Saint Barthelemy|BM:Bermuda|" +
    "BN:Brunei Darussalam|BO:Bolivia|BQ:Bonaire, Sint Eustatius and Saba|BR:Brazil|BS:Bahamas|BT:Bhutan|" +
    "BV:Bouvet Island|BW:Botswana|BY:Belarus|BZ:Belize|CA:Canada|CC:Cocos (Keeling) Islands|" +
    "CD:Congo (Democratic Republic)|CF:Central African Republic|CG:Congo|CH:Switzerland|CI:Cote d'Ivoire|" +
    "CK:Cook Islands|CL:Chile|CM:Cameroon|CN:China|CO:Colombia|CR:Costa Rica|CU:Cuba|CV:Cabo Verde|" +
    "CW:Curacao|CX:Christmas Island|CY:Cyprus|CZ:Czechia|DE:Germany|DJ:Djibouti|DK:Denmark|DM:Dominica|" +
    "DO:Dominican Republic|DZ:Algeria|EC:Ecuador|EE:Estonia|EG:Egypt|EH:Western Sahara|ER:Eritrea|" +
    "ES:Spain|ET:Ethiopia|FI:Finland|FJ:Fiji|FK:Falkland Islands|FM:Micronesia|FO:Faroe Islands|FR:France|" +
    "GA:Gabon|GB:United Kingdom|GD:Grenada|GE:Georgia|GF:French Guiana|GG:Guernsey|GH:Ghana|GI:Gibraltar|" +
    "GL:Greenland|GM:Gambia|GN:Guinea|GP:Guadeloupe|GQ:Equatorial Guinea|GR:Greece|" +
    "GS:South Georgia and the South Sandwich Islands|GT:Guatemala|GU:Guam|GW:Guinea-Bissau|GY:Guyana|" +
    "HK:Hong Kong|HM:Heard Island and McDonald Islands|HN:Honduras|HR:Croatia|HT:Haiti|HU:Hungary|" +
    "ID:Indonesia|IE:Ireland|IL:Israel|IM:Isle of Man|IN:India|IO:British Indian Ocean Territory|IQ:Iraq|" +
    "IR:Iran|IS:Iceland|IT:Italy|JE:Jersey|JM:Jamaica|JO:Jordan|JP:Japan|KE:Kenya|KG:Kyrgyzstan|" +
    "KH:Cambodia|KI:Kiribati|KM:Comoros|KN:Saint Kitts and Nevis|KP:North Korea|KR:South Korea|KW:Kuwait|" +
    "KY:Cayman Islands|KZ:Kazakhstan|LA:Laos|LB:Lebanon|LC:Saint Lucia|LI:Liechtenstein|LK:Sri Lanka|" +
    "LR:Liberia|LS:Lesotho|LT:Lithuania|LU:Luxembourg|LV:Latvia|LY:Libya|MA:Morocco|MC:Monaco|" +
    "MD:Moldova|ME:Montenegro|MF:Saint Martin (French part)|MG:Madagascar|MH:Marshall Islands|" +
    "MK:North Macedonia|ML:Mali|MM:Myanmar|MN:Mongolia|MO:Macao|MP:Northern Mariana Islands|" +
    "MQ:Martinique|MR:Mauritania|MS:Montserrat|MT:Malta|MU:Mauritius|MV:Maldives|MW:Malawi|MX:Mexico|" +
    "MY:Malaysia|MZ:Mozambique|NA:Namibia|NC:New Caledonia|NE:Niger|NF:Norfolk Island|NG:Nigeria|" +
    "NI:Nicaragua|NL:Netherlands|NO:Norway|NP:Nepal|NR:Nauru|NU:Niue|NZ:New Zealand|OM:Oman|PA:Panama|" +
    "PE:Peru|PF:French Polynesia|PG:Papua New Guinea|PH:Philippines|PK:Pakistan|PL:Poland|" +
    "PM:Saint Pierre and Miquelon|PN:Pitcairn|PR:Puerto Rico|PS:Palestine|PT:Portugal|PW:Palau|" +
    "PY:Paraguay|QA:Qatar|RE:Reunion|RO:Romania|RS:Serbia|RU:Russian Federation|RW:Rwanda|" +
    "SA:Saudi Arabia|SB:Solomon Islands|SC:Seychelles|SD:Sudan|SE:Sweden|SG:Singapore|SH:Saint Helena|" +
    "SI:Slovenia|SJ:Svalbard and Jan Mayen|SK:Slovakia|SL:Sierra Leone|SM:San Marino|SN:Senegal|" +
    "SO:Somalia|SR:Suriname|SS:South Sudan|ST:Sao Tome and Principe|SV:El Salvador|" +
    "SX:Sint Maarten (Dutch part)|SY:Syrian Arab Republic|SZ:Eswatini|TC:Turks and Caicos Islands|" +
    "TD:Chad|TF:French Southern Territories|TG:Togo|TH:Thailand|TJ:Tajikistan|TK:Tokelau|TL:Timor-Leste|" +
    "TM:Turkmenistan|TN:Tunisia|TO:Tonga|TR:Turkiye|TT:Trinidad and Tobago|TV:Tuvalu|TW:Taiwan|" +
    "TZ:Tanzania|UA:Ukraine|UG:Uganda|UM:United States Minor Outlying Islands|US:United States|" +
    "UY:Uruguay|UZ:Uzbekistan|VA:Holy See|VC:Saint Vincent and the Grenadines|VE:Venezuela|" +
    "VG:Virgin Islands (British)|VI:Virgin Islands (U.S.)|VN:Viet Nam|VU:Vanuatu|WF:Wallis and Futuna|" +
    "WS:Samoa|YE:Yemen|YT:Mayotte|ZA:South Africa|ZM:Zambia|ZW:Zimbabwe";

  var LIST = RAW.split("|").map(function (x) {
    var i = x.indexOf(":");
    return { code: x.slice(0, i), en: x.slice(i + 1) };
  });

  function localeOf() {
    var l = (document.documentElement.getAttribute("lang") || "").trim();
    return l || "pl";
  }

  function namer() {
    var loc = localeOf(), dn = null;
    try { if (w.Intl && Intl.DisplayNames) dn = new Intl.DisplayNames([loc], { type: "region" }); } catch (e) { dn = null; }
    return function (code, en) {
      if (dn) { try { var v = dn.of(code); if (v && v !== code) return v; } catch (e) {} }
      return en;
    };
  }

  /* Buduje pelna liste w podanym <select>.
     opts: { placeholder, groupAuto, groupRest, top } */
  function fill(sel, opts) {
    if (!sel || sel.getAttribute("data-cc-iso") === "1") return;
    opts = opts || {};
    var top = opts.top || TOP;
    var name = namer();
    var loc = localeOf();
    var prev = sel.value;

    var topSet = {}, i;
    for (i = 0; i < top.length; i++) topSet[top[i]] = 1;

    var byCode = {};
    for (i = 0; i < LIST.length; i++) byCode[LIST[i].code] = LIST[i];

    var rest = LIST.filter(function (x) { return !topSet[x.code]; })
      .map(function (x) { return { code: x.code, label: name(x.code, x.en) }; });
    try { rest.sort(function (a, b) { return a.label.localeCompare(b.label, loc); }); }
    catch (e) { rest.sort(function (a, b) { return a.label < b.label ? -1 : 1; }); }

    var html = '<option value="" selected>' + (opts.placeholder || "—") + "</option>";
    html += '<optgroup label="' + (opts.groupAuto || "Weryfikacja automatyczna") + '">';
    for (i = 0; i < top.length; i++) {
      var t = byCode[top[i]];
      if (!t) continue;
      html += '<option value="' + t.code + '">' + name(t.code, t.en) + " (" + t.code + ")</option>";
    }
    html += "</optgroup>";
    html += '<optgroup label="' + (opts.groupRest || "Pozostale kraje") + '">';
    for (i = 0; i < rest.length; i++) {
      html += '<option value="' + rest[i].code + '">' + rest[i].label + " (" + rest[i].code + ")</option>";
    }
    html += "</optgroup>";

    sel.innerHTML = html;
    sel.setAttribute("data-cc-iso", "1");
    if (prev) { sel.value = prev; if (sel.value !== prev) sel.value = ""; }
  }

  w.CHRISTINA_ISO_COUNTRIES = LIST;
  w.CHRISTINA_ISO_ADAPTERS = TOP;
  w.christinaFillCountrySelect = fill;
})(window);
